(function () {
  const selector = 'img[data-cm-image-skeleton]';
  const initialized = 'cmSkeletonInitialized';

  function typeClass(type) {
    return 'cm-image-skeleton-frame--' + String(type || 'default').toLowerCase().replace(/[^a-z0-9_-]+/g, '-');
  }

  function markLoaded(frame) {
    frame.classList.add('cm-image-loaded');
    frame.classList.remove('cm-image-error');
  }

  function markWaiting(frame) {
    frame.classList.remove('cm-image-loaded', 'cm-image-error');
  }

  function setupImage(img) {
    if (!img || img.dataset[initialized] === 'true') return;

    const parent = img.parentElement;
    if (!parent) return;

    const type = img.getAttribute('data-cm-image-skeleton') || 'default';
    let frame = parent.classList.contains('cm-image-skeleton-frame') ? parent : null;

    if (!frame) {
      frame = document.createElement('span');
      frame.className = 'cm-image-skeleton-frame ' + typeClass(type);
      parent.insertBefore(frame, img);
      frame.appendChild(img);
    } else {
      frame.classList.add(typeClass(type));
    }

    img.dataset[initialized] = 'true';

    const onLoad = () => markLoaded(frame);
    const onError = () => frame.classList.add('cm-image-error');

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(frame);
    } else {
      markWaiting(frame);
      img.addEventListener('load', onLoad);
      img.addEventListener('error', onError);
    }
  }

  function refresh(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(selector).forEach(setupImage);
  }

  function observe() {
    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(selector)) setupImage(node);
          refresh(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.MansaIntimaImageSkeleton = { refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      refresh(document);
      observe();
    });
  } else {
    refresh(document);
    observe();
  }
})();
